import { render, staticRenderFns } from "./ResendConfirmation.vue?vue&type=template&id=5cb3fd46&scoped=true&"
import script from "./ResendConfirmation.vue?vue&type=script&lang=js&"
export * from "./ResendConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ResendConfirmation.vue?vue&type=style&index=0&id=5cb3fd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3fd46",
  null
  
)

export default component.exports